import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Brands from './pages/Brands';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Services from './pages/Services';
import Login from './pages/admin/Login';
import AdminLayout from './components/admin/AdminLayout';
import PrivateRoute from './components/admin/PrivateRoute';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';

const PublicSite = () => (
  <div className="bg-black text-white min-h-screen">
    <Navbar />
    <main>
      <section id="home"><Home /></section>
      <section id="about"><About /></section>
      <section id="brands"><Brands /></section>
      <section id="services"><Services /></section>
      <section id="contact"><Contact /></section>
    </main>
    <Footer />
    <ScrollToTop />
  </div>
);

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <ToastProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin/*"
            element={
              <PrivateRoute>
                <AdminLayout />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<PublicSite />} />
        </Routes>
      </ToastProvider>
    </AuthProvider>
  </BrowserRouter>
);

export default App;
